var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"15px","margin-top":"15px"}},[_c('textarea',{staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"name":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }